import React from 'react';

import InfoItem from './InfoItem';
import Row from './Flex';
import Spacer from './Spacer';
import PricingTable from './PricingTable';

import * as util from '../util';
export default props => {
  const { data } = props;

  let additionalFees = [];
  if (util.exists(data.visitFee))
    additionalFees.push({ fee: 'Per-visit fee', amount: data.visitFee });
  if (util.exists(data.enrollFee))
    additionalFees.push({ fee: 'Enrollment fee', amount: data.enrollFee });
  additionalFees = [...additionalFees, ...(data.additionalFees || [])];

  return (
    <div className="section">
      <h3 className="sectiontitle">Prices and fees</h3>
      <br />
      <div className="sectionitem" style={{ width: '100%' }}>
        <InfoItem title="Membership prices">
          <PricingTable prices={data.prices} />
          {data.pricingDetails && (
            <p>
              <small>{data.pricingDetails}</small>
            </p>
          )}
        </InfoItem>
        <br />
        {additionalFees.length > 0 && (
          <InfoItem title="Additional fees">
            <PricingTable prices={additionalFees} />
          </InfoItem>
        )}
        <br />
        {(data.procedureFees || []).length > 0 && (
          <InfoItem title="Procedure fees">
            <PricingTable prices={data.procedureFees} />
          </InfoItem>
        )}
        {false &&
          (data.feeCategories || []).map(({ name, fees, details }) => {
            if (!fees || !fees.length || !name) return null;
            return (
              <InfoItem title={name}>
                <div className="table">
                  {(fees || []).map(fee => {
                    return (
                      <Row justify="space-between">
                        <span>{fee.fee}</span>
                        <Spacer size="small" />
                        <b>{fee.amount}</b>
                      </Row>
                    );
                  })}
                </div>
                {details && (
                  <p>
                    <small>{details}</small>
                  </p>
                )}
              </InfoItem>
            );
          })}
      </div>
    </div>
  );
};
